
import * as React from 'react';
import { openItem } from '../../../operations/openItem';
import { currentItemFacet } from '../../../facets/ScopeFacets';
import { openActionControl } from '../../../controls/openActionControl';
import { connectToItemCache } from '../../decorators/connectToItemCache';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { IActionProps, Action } from '../../action/Action';
import { withSelectedItems, withExactlyOneItem } from '../../decorators/selectors';
import { connectToItemsScope, IItemsScopeConnectorProps } from '../../decorators/connectToItemsScope';

const doNothing = async () => { /* Nothing */ };

/**
 * @public
 */
export interface IItemOpenActionProps {
  itemKey: string;
}

/**
 * Action which sets the given item as the current item in the current items scope context.
 * @public
 */
export const ItemOpenAction: React.ComponentType<IItemOpenActionProps> = connectToItemsScope()(
  connectToItemCache((itemCache: IItemCache, props: IItemOpenActionProps & IItemsScopeConnectorProps):
    IActionProps => {
    const {
      itemsScopeItemKey,
      itemKey
    } = props;

    const { dispatch } = itemCache;

    const currentItem = itemCache.demandItemFacet(currentItemFacet, itemsScopeItemKey);
    const currentItemKey = currentItem && currentItem.itemKey;
    const controlHandler = itemCache.demandItemFacet(openActionControl, itemKey);

    if (!itemsScopeItemKey) {
      return {};
    }

    const {
      itemKey: finalItemKey,
      openItem: finalOpenItem,
      isAvailable
    } = openActionControl.evaluate(controlHandler)(itemCache, {
      itemKey: itemKey,
      itemsScopeItemKey: itemsScopeItemKey,
      openItem: openItem,
      isAvailable: true
    });

    const onExecute = finalItemKey ? async () => {
      await dispatch(finalOpenItem({
        currentItemKey: finalItemKey,
        itemsScopeItemKey: itemsScopeItemKey
      }));
    } : doNothing;

    return {
      isAvailable: !!finalItemKey && finalItemKey !== currentItemKey && isAvailable,
      isToggled: finalItemKey === currentItemKey,
      onExecute: onExecute,
      engagement: {
        name: 'Open',
        isIntentional: true
      }
    };
  })(Action)
);

/**
 * @public
 */
export const OpenAction: React.ComponentType<{}> = withSelectedItems()(withExactlyOneItem()(ItemOpenAction));
